module.exports = __webpack_public_path__ + "static/media/modo-logo.24c654f1.png";